// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ChartDataType } from '../Utils/ChartConstants';
import { FAKE_LEFT_PADDING_BAR_INDEX, FAKE_RIGHT_PADDING_BAR_INDEX, TerceraChartCashItemSeries } from './TerceraChartCashItemSeries';
import { BarIndex } from '@shared/commons/cache/History/HistoryConstants';
export class TerceraChartOverlaySeries extends TerceraChartCashItemSeries {
    constructor(newCashItem, settings, ParentSeries) {
        super(newCashItem, settings);
        this.ParentSeries = null;
        /// <summary>
        /// Родительская серия, используется для расчета индексов
        /// </summary>
        this.ParentSeries = ParentSeries;
        this.leftPaddingBarsCount = ParentSeries.leftPaddingBarsCount;
        this.rightPaddingBarsCount = ParentSeries.rightPaddingBarsCount;
        this.RecalcIndices();
    }
    /// <summary>
    /// Пересчет индексов.
    /// Отталкиваемся от главной серии, чтобы решить проблему с дырками.
    /// </summary>
    RecalcIndices() {
        const ParentSeries = this.ParentSeries;
        if (!ParentSeries)
            return;
        let bufferList = [];
        const bufferZero = [];
        bufferZero.push(0);
        // Нелинейная шкала времени - тики, ренко и т.д. - синхронизируем по количеству
        if (ParentSeries.NonLinearTimeline && this._cashItem.ChartDataType !== ChartDataType.HeikinAshi) {
            bufferList = ParentSeries.FIndexList;
            let currentIndex = this._cashItem.Count() - 1;
            for (let i = bufferList.length - 1; i >= 0; i--) {
                if (bufferList[i] === FAKE_LEFT_PADDING_BAR_INDEX || bufferList[i] === FAKE_RIGHT_PADDING_BAR_INDEX) {
                    continue;
                }
                bufferList[i] = currentIndex;
                currentIndex--;
                if (currentIndex < 0) {
                    bufferList[i] = -1;
                }
            }
        }
        // Линейная шкала - синхронизируем по времени
        else {
            // copy from parent
            bufferList = this.ParentSeries.FIndexList.slice();
            // В дочернем кешитеме стартуем отсюда
            let currentIndex = this._cashItem.FindIntervalByTime(ParentSeries.LeftRelativeBorder);
            if (currentIndex < 0) {
                currentIndex = 0;
            }
            //
            const daysLeft = 60000 * 60 * 24;
            let averTime;
            let indexHole = 1;
            // Correction
            for (let i = 0; i < bufferList.length; i++) {
                let timeFromBase = Math.floor(this.ParentSeries.GetValue(i, BarIndex.Time));
                let timeFromCurrent = Math.floor(this._cashItem.GetByConst(currentIndex, BarIndex.Time));
                if (bufferList[i] === FAKE_LEFT_PADDING_BAR_INDEX || bufferList[i] === FAKE_RIGHT_PADDING_BAR_INDEX) {
                    continue;
                }
                // Для дневок будем хитрить
                if (this._DayBasedData) {
                    // correct base time
                    averTime = (timeFromBase + timeFromBase + this.RelativePeriodBar) / 2;
                    timeFromBase = averTime - (averTime % daysLeft);
                    // correct current time
                    averTime = (timeFromCurrent + timeFromCurrent + this.RelativePeriodBar) / 2;
                    timeFromCurrent = averTime - (averTime % daysLeft);
                }
                if (timeFromCurrent < timeFromBase) {
                    for (let j = currentIndex; currentIndex < this._cashItem.Count(); j++) {
                        currentIndex++;
                        timeFromCurrent = Math.floor(this._cashItem.GetByConst(currentIndex, BarIndex.Time));
                        // correct current time
                        if (this._DayBasedData) {
                            averTime = (timeFromCurrent + timeFromCurrent + this.RelativePeriodBar) / 2;
                            timeFromCurrent = averTime - (averTime % daysLeft);
                        }
                        if (timeFromCurrent >= timeFromBase) {
                            break;
                        }
                    }
                }
                if (timeFromCurrent === timeFromBase) {
                    bufferList[i] = currentIndex;
                    currentIndex++;
                }
                else {
                    bufferList[i] = -indexHole;
                    bufferZero.push(Math.floor(this.ParentSeries.GetValue(i, BarIndex.Time)));
                    indexHole++;
                }
            }
        }
        // replace
        this.FIndexList = bufferList;
        this.ZeroTimes = bufferZero;
        this.dataBlocks = ParentSeries.dataBlocks;
        this.LeftRelativeBorder = ParentSeries.LeftRelativeBorder;
        this.RightRelativeBorder = ParentSeries.RightRelativeBorder;
    }
}
